import React, { useEffect } from 'react';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFViewer,
    Image,
    Font,
    PDFDownloadLink
} from "@react-pdf/renderer";
import LOGO from '../../assets/img/logo.png';
import SenRegular from '../../assets/font/Sen-Regular.ttf';
import SenBold from '../../assets/font/Sen-Bold.ttf';
import SenExtraBold from '../../assets/font/Sen-ExtraBold.ttf';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrderDetails } from '../../redux/actions/OrderActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import Message from '../../components/Message';


Font.register({
    family: "Sen",
    fonts: [
        { src: SenRegular },
        { src: SenBold, fontStyle: 'normal', fontWeight: 400 },
        { src: SenExtraBold, fontStyle: 'normal', fontWeight: 700 },
    ]
})

// Font.register({
//     family: "Sen",
//     src: SenRegular,
// })


// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        fontFamily: 'Sen'
    },
    logo: {
        width: 100,
        margin: 20

    },
    title: {
        fontSize: 20,
        letterSpacing: 2,
        fontWeight: 500,
        textAlign: 'center',
        marginTop: 20,
        marginBottom: 20,
        marginLeft:20,
        marginRight:20,
    },
    viewer: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    person:{
        display: "flex", 
        justifyContent: 'space-between',
        flexDirection: 'row',
        margin: 20
    },
    
    person_title:{
        fontSize: 13,
        marginBottom: 10,
        textTransform: 'uppercase',
        color: "#DC143C",
        fontWeight: 500
    },

    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        // borderRightWidth: 0,
        // borderBottomWidth: 0,
        marginTop: 20,
        marginLeft: 20,
        marginRight: 20,
        marginBottom: 10,
        fontSize: 12
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
        marginTop: 7,
        marginBottom: 7
    },
    tableHeader: {
        margin: "auto",
        flexDirection: "row",
        backgroundColor: '#003049',
        color: '#ffffff',
        padding: 10
    },
    tableHeaderCol: {
        width: "20%",
    },
    tableCol: {
        width: "20%",
        // borderStyle: "solid",
        // borderWidth: 1,
        // borderLeftWidth: 0,
        // borderTopWidth: 0
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10
    },

    orderSummary: {
        display: "flex",
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginRight: 20,
        marginLeft: 20,
        marginBottom: 20,
    },
    
});


const MyDoc = ({ order }) => (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <Image src={LOGO} style={styles.logo} />
                </View>
                <View style={styles.title}>
                    <Text>INVOICE</Text>
                </View>

                <View style={styles.person}>
                    <View>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Invoice Number: </Text>#47826</Text>
                    </View>
                    <View>
                        <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Invoice Date: </Text>21/09/2023</Text>
                    </View>
                </View>

                <View style={styles.person}>
                    <View style={{ display: "flex", flexDirection: "column" }}>
                        <Text style={styles.person_title}>Person Details</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Name: </Text>{order.user ? order.user.name : '--'}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Email: </Text>{order.user ? order.user.email : '--'}</Text>
                        <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Phone: </Text>{order.user ? order.user.phone : '--'}</Text>
                    </View>
                    <View style={{ display: "flex", flexDirection: "column" }}>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d' }}>Order ID: </Text>{order ? order._id : '--'}</Text>
                        <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d' }}>Date: </Text>{order ? order.createdAt.substring(0, 10) : '--'}</Text>
                    </View>
                </View>

                <View style={styles.person}>
                    <View style={{ display: "flex", flexDirection: "column" }}>
                        <Text style={styles.person_title}>SHIPPING ADDRESS</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Address: </Text>{order && order.shippingAddress.address}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>City: </Text>{order && order.shippingAddress.city}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Landmark: </Text>{order && order.shippingAddress.landmark}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Postal Code: </Text>{order && order.shippingAddress.postalCode}</Text>
                        <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Country: </Text>{order && order.shippingAddress.country}</Text>
                    </View>
                    <View style={{ display: "flex", flexDirection: "column", }}>
                        <Text style={styles.person_title}>PAYMENT METHOD</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Payment ID: </Text>{order && order.razorpay.paymentId}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Method: </Text>Razorpay</Text>
                        <Text style={{ fontSize: 12, }}><Text style={{ color: '#457b9d', }}>Paid At: </Text>{order ? order.paidAt.substring(0, 10) : '--'}</Text>
                    </View>
                </View>

                <View style={{ textTransform: 'uppercase', marginTop: 20, marginLeft: 20, marginRight: 20, fontSize: 13, color: '#DC143C', fontWeight: 500 }}>
                    <Text>Products</Text>
                </View>

                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <View style={styles.tableHeaderCol}>
                            <Text style={styles.tableCell}>#</Text>
                        </View>
                        <View style={styles.tableHeaderCol}>
                            <Text style={styles.tableCell}>Product</Text>
                        </View>
                        <View style={styles.tableHeaderCol}>
                            <Text style={styles.tableCell}>Price (Rs)</Text>
                        </View>
                        <View style={styles.tableHeaderCol}>
                            <Text style={styles.tableCell}>Qty</Text>
                        </View>
                        <View style={styles.tableHeaderCol}>
                            <Text style={styles.tableCell}>Total (Rs)</Text>
                        </View>
                    </View>
                    {
                        order && order.orderItems.map(item => (
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>1</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>{item.name}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>{item.price}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>{item.qty}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>{item.price}</Text>
                                </View>
                            </View>
                        ))
                    }

                </View>


                <View style={styles.orderSummary}>
                    <View></View>
                    <View style={{ display: "flex", flexDirection: "column", marginRight: 35 }}>
                        <Text style={{ fontSize: 12, marginBottom: 7 }}><Text style={{ color: '#457b9d', }}>Items (Rs): &nbsp;  &nbsp;  &nbsp; </Text> {order && order.itemsPrice}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 7 }}><Text style={{ color: '#457b9d', }}>Shipping (Rs):  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; </Text>{order && order.shippingPrice}</Text>
                        <Text style={{ fontSize: 12, marginBottom: 10 }}><Text style={{ color: '#457b9d', }}>Tax (Rs):  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp; &nbsp;</Text>{order && order.taxPrice}</Text>
                        <Text style={{ border: 1 }}></Text>
                        <Text style={{ fontSize: 15, marginTop: 10, fontWeight: 500 }}><Text style={{ color: '#DC143C', }}>Total (Rs): &nbsp; &nbsp;</Text>{order && order.totalPrice}</Text>
                    </View>
                </View>
            </Page>
        </Document>
)

const Invoice = () => {

    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const orderDetails = useSelector((state) => state.orderDetails)
    const { loading, order, error } = orderDetails;

    const authLogin = useSelector((state) => state.authLogin)
    const { info } = authLogin;


    useEffect(() => {

        if (!info) {
            navigate('/login')
        }


        if (!order || order._id !== id) {
            dispatch(getOrderDetails(id))
        }

    }, [id, order, authLogin, dispatch, navigate, info])

    if (!loading) {
        const addDecimals = (num) => {
            return (Math.round(num * 100) / 100).toFixed(2)
        }

        order.itemsPrice = addDecimals(
            order.orderItems.reduce((acc, item) => acc + item.price * item.qty, 0)
        )
    }


    


    return (
        <>
            { loading ? <Loader /> : error ? <Message error msg={error} /> : (
                <div>
                    <div>
                        <PDFDownloadLink document={<MyDoc order={order} />} fileName="somename.pdf">
                            {({ _blob, _url, loading, _error }) => (loading ? 'Loading document...' : 'Download now!')}
                        </PDFDownloadLink>
                    </div>
                    <PDFViewer style={styles.viewer}>
                        <MyDoc order={order} />
                    </PDFViewer>
                </div>
            )}
        </>
    )
}

export default Invoice;